import React from 'react';
import { IntegrationField, JiraField, Option } from 'api/integrations';
import { Input, TextArea } from 'components/atoms/input';
import {
  filterableFieldType,
  IntegrationFieldType,
  IntegrationDateField,
  IntegrationInputField,
  IntegrationMultiSelectField,
  IntegrationNumberField,
  IntegrationSelectField,
} from 'components/molecules/integrations-commons';

export const convertFieldOptionToSelect = (field: JiraField) =>
  (field.metaData?.options || []).map((option) => ({
    value: option.valueStr,
    ...option,
  }));

type GenerateDynamicTableCells = {
  field: IntegrationField;
  onFieldValueChange: (valObject: any) => void;
  metaData?: any;
  options?: Option[];
  loading?: boolean;
  disabled?: boolean;
};

export const generateDynamicTableCells = ({
  field,
  onFieldValueChange,
  metaData,
  options,
  loading,
  disabled,
}: GenerateDynamicTableCells) => {
  switch (filterableFieldType(field)) {
    case IntegrationFieldType.Description: {
      return <Input disabled value="Task Description" />;
    }

    case IntegrationFieldType.Text: {
      return (
        <IntegrationInputField
          field={field}
          value={metaData?.default ?? ''}
          onChange={onFieldValueChange}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.Number: {
      return (
        <IntegrationNumberField
          field={field}
          value={metaData?.default ?? ''}
          onChange={onFieldValueChange}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.TextArea: {
      return <TextArea disabled={disabled} onChange={onFieldValueChange} />;
    }

    case IntegrationFieldType.Date: {
      return (
        <IntegrationDateField
          field={field}
          value={metaData?.default}
          onChange={onFieldValueChange}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.SingleSelect: {
      return (
        <IntegrationSelectField
          field={field}
          value={metaData?.default ?? ''}
          onChange={onFieldValueChange}
          options={options}
          loading={loading}
          disabled={disabled}
        />
      );
    }

    case IntegrationFieldType.MultiSelect: {
      return (
        <IntegrationMultiSelectField
          field={field}
          value={metaData?.default ?? ''}
          onChange={onFieldValueChange}
          options={options}
          loading={loading}
          disabled={disabled}
        />
      );
    }

    default: {
      return <></>;
    }
  }
};
